/**
 * Shop Selector Handling
 *
 * @type {AsyncDynamicInitFunction<HTMLElement>}
 */
export default async ($collection) => {

	const { 'default': handleShopSelector } = await import('./not-logged/shop-selector-handler.js');

	for (const triggerInput of $collection) {
		handleShopSelector(triggerInput);
	}
};